

export class PermissionUpdate {
    permissionGroupId: number = 0;
    permissionGroupName: string = '';
    notificationGroup: boolean = false;
    permissions = new Array();
    previousGroupIsNotification:boolean = false;
    permissionsToRemove = new Array();
}